/**
 * @generated SignedSource<<9e3c9e0195afb567e0e4b62d80a9d346>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TeamScheduleHistoryDetailQuery$variables = {
  id: string;
};
export type TeamScheduleHistoryDetailQuery$data = {
  readonly teamSchedule: {
    readonly allDayEvents: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion">;
    }>;
    readonly events: ReadonlyArray<{
      readonly __typename: "RoutineOccasion";
      readonly assigned?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly assignedRoles?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly routine?: {
        readonly description: string | null;
        readonly descriptionImages: ReadonlyArray<{
          readonly __typename: "Image";
        }>;
      };
      readonly taskExecution?: {
        readonly routineOccasion: {
          readonly assigned: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly assignedRoles: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly routine: {
            readonly description: string | null;
            readonly descriptionImages: ReadonlyArray<{
              readonly __typename: "Image";
            }>;
          };
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion">;
    }>;
    readonly freq: RoutineScheduleType;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryDetailTitle_teamSchedule">;
  } | null;
};
export type TeamScheduleHistoryDetailQuery = {
  response: TeamScheduleHistoryDetailQuery$data;
  variables: TeamScheduleHistoryDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freq",
  "storageKey": null
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleListItem_TeamScheduleEventOccasion"
},
v5 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTeamScheduleEventOccasion"
},
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "TIME_ONLY"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "deadlineAtDate",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v22/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v27/*: any*/)
      ],
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v20/*: any*/),
        (v19/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v20/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            (v27/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedTaskExecutionCount",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v34/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v25/*: any*/),
            (v26/*: any*/),
            (v2/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        (v22/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v23/*: any*/),
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isScheduledOccasion"
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    (v17/*: any*/),
    (v18/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notDoneStatus",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskCheck",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sectionId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAtDate",
      "plural": false,
      "selections": (v13/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TeamScheduleOneOffEvent",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleHistoryDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamSchedule",
        "kind": "LinkedField",
        "name": "teamSchedule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamScheduleHistoryDetailTitle_teamSchedule"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "allDayEvents",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "RoutineOccasion",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TeamScheduleInlineRoutineOccasion",
                "abstractKey": null
              }
            ],
            "storageKey": "events(includeInlineRoutines:true)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamScheduleHistoryDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamSchedule",
        "kind": "LinkedField",
        "name": "teamSchedule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "allDayEvents",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/),
              (v12/*: any*/),
              (v37/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v2/*: any*/),
                          (v38/*: any*/),
                          (v31/*: any*/),
                          (v39/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v35/*: any*/),
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "type": "TeamScheduleInlineRoutineOccasion",
                "abstractKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/),
              (v12/*: any*/),
              (v37/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v2/*: any*/),
                          (v38/*: any*/),
                          (v31/*: any*/),
                          (v39/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "descriptionImages",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v35/*: any*/),
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "type": "TeamScheduleInlineRoutineOccasion",
                "abstractKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": "events(includeInlineRoutines:true)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1918f96fe4253cb4b30a9d9df6527c9",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleHistoryDetailQuery",
    "operationKind": "query",
    "text": "query TeamScheduleHistoryDetailQuery(\n  $id: ID!\n) {\n  teamSchedule(id: $id) {\n    id\n    freq\n    ...TeamScheduleHistoryDetailTitle_teamSchedule\n    allDayEvents {\n      __typename\n      id\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n    }\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n      ... on RoutineOccasion {\n        __typename\n        assigned {\n          id\n        }\n        assignedRoles {\n          id\n        }\n        routine {\n          description\n          descriptionImages {\n            __typename\n            id\n          }\n          id\n        }\n      }\n      ... on TeamScheduleInlineRoutineOccasion {\n        __typename\n        taskExecution {\n          routineOccasion {\n            assigned {\n              id\n            }\n            assignedRoles {\n              id\n            }\n            routine {\n              description\n              descriptionImages {\n                __typename\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionListItemAssignedEmployees_RoutineOccasion on RoutineOccasion {\n  assigned {\n    id\n    employee {\n      id\n      isLinkedToViewer\n      ...ListItemAssignees_employees\n    }\n    assignedAt\n  }\n  assignedRoles {\n    role {\n      ...ListItemAssignees_roles\n      id\n    }\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment TeamScheduleHistoryDetailTitle_teamSchedule on TeamSchedule {\n  id\n  label\n}\n\nfragment TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  startAt\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      notDoneStatus\n      completedTaskExecutionCount\n      totalTaskExecutionCount\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n      ...TeamScheduleRoutineListItemContent_RoutineOccasion\n      ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n      ...TeamScheduleListItemScheduleRange_routineOccasion\n    }\n    routine {\n      ...TeamScheduleRoutineListItemContent_Routine\n      id\n    }\n    checkValue\n  }\n}\n\nfragment TeamScheduleListItemMonthlyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItemScheduleRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  ...TeamScheduleListItemWeeklyRange_routineOccasion\n  ...TeamScheduleListItemMonthlyRange_routineOccasion\n}\n\nfragment TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ... on RoutineOccasion {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    deadlineAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        startAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        deadlineAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        id\n      }\n      id\n    }\n  }\n  ... on TeamScheduleOneOffEvent {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    endAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n}\n\nfragment TeamScheduleListItemWeeklyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItem_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ...TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion\n  ... on RoutineOccasion {\n    ...TeamScheduleRoutineOccasionListItem_RoutineOccasion\n    routine {\n      id\n      isArchived\n      ...RoutineOccasionScreenRoutineDescription_Routine\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    ...TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  title\n  isOrg\n  description\n  orgIconUri\n  isArchived\n  ...RoutineOccasionScreenRoutineDescription_Routine\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  assigned {\n    employee {\n      id\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  ...RoutineOccasionListItemAssignedEmployees_RoutineOccasion\n}\n\nfragment TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment TeamScheduleRoutineOccasionListItem_RoutineOccasion on RoutineOccasion {\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...TeamScheduleRoutineListItemContent_RoutineOccasion\n  ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n  ...TeamScheduleListItemScheduleRange_routineOccasion\n  sequenceNumber\n  completedTaskExecutionCount\n  totalTaskExecutionCount\n  routine {\n    id\n    ...TeamScheduleRoutineListItemContent_Routine\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd91bb2cff36de80c6ba02880a150882";

export default node;
